import React from 'react'
import FontAwesome from 'react-fontawesome'

export default function(props) {
    const { title, onClose } = props

    return (
        <div className="modal-header" style={{ cursor: 'move' }}>
            <div></div>
            <h4 className="modal-title"><FontAwesome name="window-maximize" style={{ color: '#555' }} />{ title }</h4>
            <button type="button" className="close" aria-label="Close" onClick={ onClose }><span aria-hidden="true">&times;</span></button>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Shared/ModalHeader.jsx